/**
 * @generated SignedSource<<162ee7a2e9f8543a0bbea1628476aa67>>
 * @relayHash c5a34794525c2f9b908664590da411ef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a07dce46ad1321dd339e972f35d84524b4ad785a58ef43fa8db52899ada24eb8

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GrowthUnifiedProfileRollingDateIntervalInput = "DAYS_1" | "DAYS_180" | "DAYS_270" | "DAYS_30" | "DAYS_365" | "DAYS_7" | "DAYS_90" | "%future added value";
export type ui_onboardingHubQuery$variables = {
  cloudId: string;
  insightsEnabled: boolean;
  rollingIntervals: ReadonlyArray<GrowthUnifiedProfileRollingDateIntervalInput>;
};
export type ui_onboardingHubQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"insightsPanel_onboardingHub" | "table_onboardingHub_OnboardingListTable">;
};
export type ui_onboardingHubQuery = {
  response: ui_onboardingHubQuery$data;
  variables: ui_onboardingHubQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "insightsEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rollingIntervals"
},
v3 = [
  {
    "kind": "ScalarField",
    "name": "date"
  },
  {
    "kind": "ScalarField",
    "name": "value"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ui_onboardingHubQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "table_onboardingHub_OnboardingListTable"
      },
      {
        "condition": "insightsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "insightsPanel_onboardingHub"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ui_onboardingHubQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "JiraOnboardingConfigConnection",
        "kind": "LinkedField",
        "name": "jira_onboardingConfigs",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraOnboardingConfigEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraOnboardingConfig",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "onboardingConfigAri"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "targetValues"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "updatedAt"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "insightsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "tenantId",
                "variableName": "cloudId"
              }
            ],
            "concreteType": "GrowthUnifiedProfileSiteProfileResult",
            "kind": "LinkedField",
            "name": "growthUnifiedProfile_siteProfile",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "rollingIntervals",
                    "variableName": "rollingIntervals"
                  }
                ],
                "concreteType": "GrowthUnifiedProfileSiteOnboardingInsightsResult",
                "kind": "LinkedField",
                "name": "onboardingHubInsightsOverAll",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "totalViews"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "avgResourceEngagement"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "rollingInterval"
                  },
                  {
                    "concreteType": "GrowthUnifiedProfileViewSeries",
                    "kind": "LinkedField",
                    "name": "viewSeries",
                    "plural": true,
                    "selections": (v3/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "name": "completionRate"
                  },
                  {
                    "concreteType": "GrowthUnifiedProfileCompletionSeries",
                    "kind": "LinkedField",
                    "name": "completionSeries",
                    "plural": true,
                    "selections": (v3/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a07dce46ad1321dd339e972f35d84524b4ad785a58ef43fa8db52899ada24eb8",
    "metadata": {},
    "name": "ui_onboardingHubQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bb997c0e92b39cddab2e3b38359728d0";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
